// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';

interface i_pie_chart_props {
    percentage: number;
    is_warn_color?: boolean;
    is_success_color?: boolean;
    is_full_color?: boolean;
    is_disabled_color?: boolean;
}

export const Pie_chart = (props: i_pie_chart_props)=>{
    const {percentage, is_success_color, is_warn_color,
        is_full_color, is_disabled_color} = props;
    const size = 24;
    const radius = size / 2;
    const angle = Math.min(percentage, 99.99)/ 100 * 360;
    const radians = Math.PI / 180 * angle;
    const x = radius + radius * Math.cos(radians - Math.PI / 2);
    const y = radius + radius * Math.sin(radians - Math.PI / 2);
    const largeArcFlag = percentage > 50 ? 1 : 0;
    const fill_bg_color = is_disabled_color
        ? 'rgba(173, 181, 189, 0.2)'
        : is_full_color
        ? 'var(--plan-table-bandwidth-full-bg-color)'
        : is_warn_color
        ? 'var(--plan-table-bandwidth-warn-bg-color)'
        : is_success_color
        ? 'var(--plan-table-bandwidth-success-bg-color)'
        : 'var(--plan-table-pie-bg-color)';
    const fill_main_color = is_disabled_color
        ? 'rgba(173, 181, 189, 0.4)'
        : is_full_color
        ? 'var(--plan-table-bandwidth-full-main-color)'
        : is_warn_color
        ? 'var(--plan-table-bandwidth-warn-main-color)'
        : is_success_color
        ? 'var(--plan-table-bandwidth-success-main-color)'
        : 'var(--plan-table-pie-main-color)';
    const op = is_success_color ? 0.2 : 1;

    const arcPath = `
      M ${radius} ${radius}
      L ${radius} 0
      A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x} ${y}
      Z
    `;

    return (
      <svg width={size} height={size}>
        <circle
          cx={radius}
          cy={radius}
          r={radius-0.5}
          fill={fill_bg_color}
          opacity={op}
        />
        <path d={arcPath} fill={fill_main_color} />
      </svg>
    );
};
